import {inject, Injectable} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {
  Condition,
  ConditionFormBuilder,
  OperatorGroups,
} from '@em/shared/mapping-engine/domain-models';
import {conditionValidator} from '../../validators/condition.validator';

@Injectable()
export class MappingEngineConditionFormBuilderService extends ConditionFormBuilder<Condition> {
  private readonly _fb = inject(UntypedFormBuilder);

  private _operatorGroups: OperatorGroups | undefined;
  updateOperatorGroups(operatorGroups: OperatorGroups) {
    this._operatorGroups = operatorGroups;
  }

  override buildCondition(condition: Condition): UntypedFormGroup {
    return this._fb.group(
      {
        leftOperand: [condition.leftOperand || '', Validators.required],
        operator: [condition.operator || '', Validators.required],
        rightOperand: [
          condition.rightOperand || null,
          this.isRequiredRightOperand(this._operatorGroups, condition.operator)
            ? [Validators.required]
            : [],
        ],
      },
      {validators: [conditionValidator(this._operatorGroups)]},
    );
  }

  isRequiredRightOperand(
    operatorGroups: OperatorGroups | undefined,
    operatorName: string | undefined,
  ): boolean {
    return !!operatorGroups?.some((group) => {
      const operator = group.operators.find((op) => op.name === operatorName);
      return operator && operator.requireRightOperand;
    });
  }
}
